import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function ShareScreenSolidIcon(props, ref) {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M1.288 20.712A.965.965 0 0 0 2 21h20c.283 0 .52-.096.712-.288A.968.968 0 0 0 23 20a.968.968 0 0 0-.288-.712A.968.968 0 0 0 22 19H2a.967.967 0 0 0-.712.288A.968.968 0 0 0 1 20c0 .283.096.52.288.712Zm1.299-3.299A1.926 1.926 0 0 1 2 16V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 3h16c.55 0 1.02.196 1.413.587.39.393.587.863.587 1.413v11c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 18H4c-.55 0-1.02-.196-1.413-.587Zm10.12-10.12a1 1 0 0 0-1.414 0l-2.5 2.5a1 1 0 0 0 1.414 1.414l.793-.793V13a1 1 0 1 0 2 0v-2.586l.793.793a1 1 0 0 0 1.414-1.414l-2.5-2.5Z"
    })
  });
}
;
ShareScreenSolidIcon.displayName = "ShareScreenSolidIcon";
export default forwardRef(ShareScreenSolidIcon);